<template>
	<div>
		<case-form :schema="schema" class="mt6" />
		<div class="fs4 fw7 lh125 mt6 mb2">If “Yes,” please provide details:</div>
		<j-accordion
			v-for="i in 3"
			:key="i"
			class="b1 bc7 mb2 r2"
			colorWhenClosed="bg5"
			colorWhenOpen="bg2"
		>
			<div slot="title" class="p2">
				<span class="mr1">Details</span>
				{{ i }}
			</div>
			<div slot="body" class="pr6 pl6 pt6 pb2 bg5">
				<case-form :schema="schemaList(i)" :isBoxed="false" />
			</div>
		</j-accordion>
	</div>
</template>

<script>
import CaseForm from "@/modules/caseManagement/components/CaseForm/CaseForm.vue"
import JAccordion from "@/components/JAccordion/"

export default {
	components: {
		CaseForm,
		JAccordion
	},

	data() {
		return {}
	},

	computed: {
		schema() {
			return [
				{
					label: `Have you ever used tobacco or nicotine products in any form (including but not limited to cigarettes,
cigars, cigarillos, pipe, chewing tobacco, marijuana, nicotine patches, gum or shisha)? `,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0useTobaccoOrNicotineProduct`,
					props: {
						suggest: {
							typeIncludes: `useTobaccoOrNicotineProduct`
						},
						createOptions: {
							type: `useTobaccoOrNicotineProduct`,
							dataType: "boolean"
						}
					}
				}
			]
		}
	},

	methods: {
		schemaList(i) {
			return [
				{
					label: `Product`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0tobaccoProduct${i}`,
					props: {
						suggest: {
							typeIncludes: `tobaccoProduct${i}`
						},
						createOptions: {
							type: `tobaccoProduct${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Amount and frequency of use`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0tobaccoFrequency${i}`,
					props: {
						suggest: {
							typeIncludes: `tobaccoFrequency${i}`
						},
						createOptions: {
							type: `tobaccoFrequency${i}`,
							dataType: "string"
						}
					}
				},
				{
					label: `Date last used`,
					component: "entityFact",
					entity: "case.insureds[0]",
					relation: "case.insureds[0].facts",
					bindTo: `case.facts.insured0tobaccoDateLastUsed${i}`,
					props: {
						suggest: {
							typeIncludes: `tobaccoDateLastUsed${i}`
						},
						createOptions: {
							type: `tobaccoDateLastUsed${i}`,
							dataType: "date"
						}
					}
				}
			]
		}
	}
}
</script>
